import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getPrompt, type PromptTemplate } from "@/api/prompts";
import { PromptDetailContent } from "@/components/prompts/prompt-detail-content";

export function SettingsPromptDetailPage() {
  const { kind } = useParams<{ kind: string }>();
  const { data: prompt, isLoading, error } = useQuery<PromptTemplate>({
    queryKey: ["prompt", kind],
    queryFn: () => getPrompt(kind!),
    enabled: !!kind,
    staleTime: 30_000,
  });

  return (
    <div className="space-y-6">
      <header className="mb-8">
        <Link
          to="/settings/prompts"
          className="text-xs text-muted-foreground hover:text-foreground"
        >
          &larr; Back to prompts
        </Link>
      </header>

      {isLoading && (
        <div className="flex items-center justify-center py-16">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-muted border-t-brand" />
        </div>
      )}
      {error && <p className="text-sm text-destructive">Failed to load prompt template.</p>}

      {prompt && <PromptDetailContent prompt={prompt} />}
    </div>
  );
}
